<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Total inventario (arriba del buscador) -->
      <h5 class="mb-3">
        Total Inventario General: Q{{ totalInventario.toFixed(2) }}
      </h5>

      <!-- Campo de búsqueda y filtros -->
      <div class="row mb-3 g-3">
        <div class="col-md-4">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar por nombre"
            v-model="filtroNombre"
            @input="aplicarFiltros"
          />
        </div>
        <div class="col-md-3">
          <select class="form-select" v-model="filtroTipo" @change="aplicarFiltros">
            <option value="">Filtrar por tipo...</option>
            <option v-for="tipo in catalogoTipos" :key="tipo.IdTipoProducto" :value="tipo.IdTipoProducto">
              {{ tipo.NombreTipo }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <select class="form-select" v-model="ordenarPor" @change="aplicarFiltros">
            <option value="">Ordenar por...</option>
            <option value="nombre-asc">Nombre (A-Z)</option>
            <option value="nombre-desc">Nombre (Z-A)</option>
            <option value="tipo-asc">Tipo (A-Z)</option>
            <option value="tipo-desc">Tipo (Z-A)</option>
          </select>
        </div>
        <div class="col-md-2">
          <button class="btn btn-secondary w-100" @click="limpiarFiltros">Limpiar</button>
        </div>
      </div>

      <!-- Toast de alerta -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
     <div class="d-flex justify-content-between align-items-center mb-2">
  <h3 class="m-0">Inventario General Restaurante</h3>
  <button class="btn btn-success" @click="mostrarFormulario = true">
    Agregar Producto
  </button>
</div>

<!-- Botón PDF debajo del título -->
<div class="mb-4">
  <button class="btn btn-danger" @click="descargarPDF">
    <i class="bx bxs-file-pdf"></i> Generar Reporte PDF
  </button>
</div>


      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Producto</h5>
        <div class="row g-4">
          <div class="col-md-3">
            <label class="form-label">Nombre</label>
            <input v-model="nuevoProducto.NombreProducto" type="text" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Tipo</label>
            <select v-model="nuevoProducto.IdTipoProducto" class="form-select">
              <option value="">Seleccionar tipo...</option>
              <option v-for="tipo in catalogoTipos" :key="tipo.IdTipoProducto" :value="tipo.IdTipoProducto">
                {{ tipo.NombreTipo }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label">Stock Actual</label>
            <input v-model.number="nuevoProducto.StockActual" type="number" min="0" class="form-control" />
          </div>
          <div class="col-md-2">
            <label class="form-label">Unidad</label>
            <select v-model="nuevoProducto.UnidadMedida" class="form-select">
              <option value="UNIDAD">Unidad</option>
              <option value="ONZAS">Onzas</option>
              <option value="LIBRAS">Libras</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label">Precio Costo (Q)</label>
            <input v-model.number="nuevoProducto.PrecioCosto" type="number" min="0" step="0.01" class="form-control" />
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarProducto">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th>Tipo</th>
              <th>Stock Actual</th>
              <th>Unidad</th>
              <th>Precio Costo (Q)</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="productos.length === 0">
              <td colspan="7">No hay productos registrados.</td>
            </tr>
            <tr v-for="prod in productos" :key="prod.IdProductoRestaurante">
              <td><strong>{{ prod.IdProductoRestaurante }}</strong></td>
              <td>{{ prod.NombreProducto }}</td>
              <td><span v-if="prod.tipo_producto" class="badge bg-secondary">{{ prod.tipo_producto.NombreTipo }}</span><span v-else>-</span></td>
              <td>{{ prod.StockActual }}</td>
              <td><span class="badge bg-info">{{ prod.UnidadMedida || 'unidad' }}</span></td>
              <td>Q.{{ Number(prod.PrecioCosto || 0).toFixed(2) }}</td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(prod)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(prod)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Actualizar -->
      <div v-if="mostrarModal" class="modal-backdrop" @click.self="cerrarModal">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Producto</h5>
            <button type="button" class="btn-close" @click="cerrarModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row g-4">
              <div class="col-md-6">
                <label class="form-label">Nombre</label>
                <input v-model="productoEditar.NombreProducto" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Tipo</label>
                <select v-model="productoEditar.IdTipoProducto" class="form-select">
                  <option value="">Sin tipo</option>
                  <option v-for="tipo in catalogoTipos" :key="tipo.IdTipoProducto" :value="tipo.IdTipoProducto">
                    {{ tipo.NombreTipo }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Stock Actual</label>
                <input v-model.number="productoEditar.StockActual" type="number" min="0" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Unidad</label>
                <select v-model="productoEditar.UnidadMedida" class="form-select">
                  <option value="unidad">Unidad</option>
                  <option value="onzas">Onzas</option>
                  <option value="libras">Libras</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Precio Costo (Q)</label>
                <input v-model.number="productoEditar.PrecioCosto" type="number" min="0" step="0.01" class="form-control" />
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary me-2" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarProducto">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar el producto <strong>{{ productoEliminar?.NombreProducto }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary me-2"  @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "InventarioGeneralRestaurante",
  data() {
    return {
      productos: [],
      catalogoTipos: [],
      copiaLista: [], // respaldo para total y restablecer filtros
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      filtroNombre: "",
      filtroTipo: "",
      ordenarPor: "",
      productoEditar: null,
      productoEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevoProducto: {
        NombreProducto: "",
        IdTipoProducto: "",
        StockActual: "",
        PrecioCosto: "",
        UnidadMedida: "unidad"
      }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
    totalInventario() {
      // Suma sobre la lista completa (no la filtrada)
      const lista = this.copiaLista?.length ? this.copiaLista : this.productos;
      return lista.reduce((acc, p) => {
        const stock = Number(p.StockActual) || 0;
        const costo  = Number(p.PrecioCosto) || 0;
        return acc + stock * costo;
      }, 0);
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerProductos() {
      try {
        const params = {};
        if (this.filtroNombre) params.nombre = this.filtroNombre;
        if (this.filtroTipo) params.id_tipo = this.filtroTipo;

        if (this.ordenarPor) {
          const [campo, direccion] = this.ordenarPor.split('-');
          params.ordenar_por = campo;
          params.direccion = direccion;
        }

        const { data } = await axios.get(`${API_URL}/inventario-general-restaurante`, { params });
        this.productos = data;
        this.copiaLista = data; // importante para el total
      } catch (error) {
        console.error(error);
      }
    },
    async obtenerCatalogoTipos() {
      try {
        const { data } = await axios.get(`${API_URL}/tipos-producto-restaurante`);
        this.catalogoTipos = data;
      } catch (error) {
        console.error(error);
      }
    },
    aplicarFiltros() {
      this.obtenerProductos();
    },
    limpiarFiltros() {
      this.filtroNombre = "";
      this.filtroTipo = "";
      this.ordenarPor = "";
      this.obtenerProductos();
    },
    async guardarProducto() {
      const { NombreProducto, StockActual, PrecioCosto } = this.nuevoProducto;
      if (!NombreProducto || StockActual === "" || PrecioCosto === "") {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      if (StockActual < 0) {
        this.mostrarAlerta("El stock no puede ser negativo", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/inventario-general-restaurante`, this.nuevoProducto);
        this.mostrarAlerta("Producto agregado", "success");
        this.nuevoProducto = { NombreProducto: "", StockActual: "", PrecioCosto: "", UnidadMedida: "unidad" };
        this.mostrarFormulario = false;
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        const mensaje =
          error.response?.data?.message ||
          error.response?.data?.errors?.NombreProducto?.[0] ||
          "Error al guardar";
        this.mostrarAlerta(mensaje, "danger");
      }
    },
    abrirModal(producto) {
      this.productoEditar = { ...producto };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.productoEditar = null;
      this.mostrarModal = false;
    },
    async actualizarProducto() {
      if (this.productoEditar.StockActual < 0) {
        this.mostrarAlerta("El stock no puede ser negativo", "danger");
        return;
      }
      try {
        await axios.put(
          `${API_URL}/inventario-general-restaurante/${this.productoEditar.IdProductoRestaurante}`,
          this.productoEditar
        );
        this.mostrarAlerta("Producto actualizado", "success");
        this.cerrarModal();
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        const mensaje =
          error.response?.data?.message ||
          error.response?.data?.errors?.NombreProducto?.[0] ||
          "Error al guardar";
        this.mostrarAlerta(mensaje, "danger");
      }
    },
    abrirModalEliminar(producto) {
      this.productoEliminar = { ...producto };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mostrarModalEliminar = false;
      this.productoEliminar = null;
    },
     descargarPDF() {
    const params = {};
    if (this.filtroNombre) params.nombre = this.filtroNombre;
    if (this.filtroTipo) params.id_tipo = this.filtroTipo;
    if (this.ordenarPor) {
      const [campo, dir] = this.ordenarPor.split('-');
      params.ordenar_por = campo;
      params.direccion = dir;
    }
    axios.get(`${API_URL}/reporte-inventario-general-restaurante`, {
      responseType: 'blob', params
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'reporte_inventario_general_restaurante.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch(error => {
      console.error('Error descargando PDF:', error);
      this.mostrarAlerta('Error al generar el reporte PDF', 'danger');
    });
  },
    async confirmarEliminar() {
      try {
        await axios.delete(
          `${API_URL}/inventario-general-restaurante/${this.productoEliminar.IdProductoRestaurante}`
        );
        this.mostrarAlerta("Producto eliminado", "success");
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoProducto = { NombreProducto: "", IdTipoProducto: "", StockActual: "", PrecioCosto: "", UnidadMedida: "unidad" };
    }
  },
  mounted() {
    this.obtenerProductos();
    this.obtenerCatalogoTipos();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.modal-content {
  background: #fff;
  width: 550px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,.3);
  z-index: 5001;
}
.modal-header { position: relative; }
.modal-header .btn-close {
  position: relative;
  z-index: 6000;
  pointer-events: auto;
}
</style>
